<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div [formGroup]="theForm" class="swimlane-edit-button-row">
	<ng-container *ngIf="!tooSmall; else tooSmallTemplate">
		<div class="swimlane-edit-label-wrapper explicit-interactable">
			<input
				type="text"
				formControlName="label"
				automationId="swimlaneName"
				class="plan-input-font-defaults"
				placeholder="Enter swim lane label"
			/>
			<span class="swimlane-edit-color-picker">
				<!--<color-picker></color-picker>-->
				<color-picker
					[alpha]="0.1"
					[format]="'rgb'"
					(move)="colorMoved($event)"
					automationId="swimlaneColorpicker"
					formControlName="color"
				></color-picker>
			</span>
			<div class="edit-pencil-wrapper"><i class="material-icons edit-pencil">mode_edit</i></div>
		</div>
		<fancy-checkbox
			class="same-row-next-control"
			formControlName="includeTicketsCheckbox"
			automationId="swimlaneIncludeTickets"
			>Include tickets</fancy-checkbox
		>

		<div class="swimlane-buttons">
			<button
				(click)="delete()"
				class="legacy-button btn--white btn--right-margin explicit-interactable"
				automationId="swimlaneDelete"
			>
				Delete
			</button>
			<button (click)="close()" class="legacy-button explicit-interactable" automationId="swimlaneDone">
				Done
			</button>
		</div>
	</ng-container>

	<ng-template #tooSmallTemplate>
		{{ strings.SWIMLANE_TOO_SMALL }}
	</ng-template>
</div>
